<template>
  <div id="app" style="height: 100vh">
    <v-container fluid fill-height>
      <v-row>
        <v-col cols="12">
          <div v-if="showDiv1" :class="{ fade: showDiv1 }">
            <v-row>
              <v-col cols="12" class="d-flex justify-center align-center">
                <v-img max-width="200px" max-height="100px" src="../../public/imagenes/logo.svg" />
              </v-col>
            </v-row>
          </div>
          <div v-else :class="{ fadeinverse: !showDiv1 }">
            <mensajeSistema />
            <v-row>
              <v-col cols="12" class="d-flex justify-center align-center">
                <v-card dark color="#1565c052" class="rounded-xl" max-width="450px">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" class="d-flex justify-center py-4">
                        <v-img maxWidth="180" pa-0 src="../../public/imagenes/logo.svg" class="img" />
                      </v-col>
                      <v-col cols="12" class="text-center">
                        <p class="color_subtitle">¡COMIENZA YA!</p>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-text-field v-model="dato.usuario" label="Usuario" type="text" dark dense outlined
                          hide-details autocomplete="off" autofocus v-on:keydown.enter.prevent="formKey('password')"
                          ref="usuario">
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" class="pb-0">
                        <v-text-field v-model="dato.password" :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="showpass ? 'text' : 'password'" label="Contraseña" dark dense hide-details outlined
                          autocomplete="off" v-on:keydown.enter.prevent="validarLogin" ref="password"
                          @click:append="showpass = !showpass">
                        </v-text-field>
                      </v-col>

                      <v-hover v-slot="{ hover }">
                        <v-col cols="12" class="d-flex justify-center">
                          <v-btn text :color="hover ? '#ffcc00' : 'white'" v-on:click="forgetPassword">¿Olvidaste tu
                            contraseña?</v-btn>
                        </v-col>
                      </v-hover>

                      <v-col cols="12">
                        <v-hover v-slot="{ hover }">
                          <v-btn class="btn_block_style1" :elevation="hover ? 12 : 4" color="primary" dark block
                            @click="validarLogin">Iniciar Sesión</v-btn>
                        </v-hover>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>


    <v-form lazy-validation>
      <ComunDialogComp v-model="modal_password" maxWidth="500" @close-modal="modal_password = false"
        title="Recuperar contraseña">
        <template v-slot:body>
          <v-row dense>
            <v-col>
              <!-- {{ itemsUser }} -->
            </v-col>
            <v-col cols="12">
              <!-- <v-autocomplete v-model="pUsuario.user" label="Documento de identidad" :items="itemsUser"
                :loading="isLoading" item-text="usu_usuario" item-value="id" return-object :search-input.sync="search">
              </v-autocomplete> -->

              <v-autocomplete v-model="pUsuario.user" label="Documento de identidad" :items="itemsUser"
                :loading="isLoading" item-text="usu_usuario" chips clearable hide-details hide-selected item-value="id"
                :search-input.sync="search" return-object>
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title>
                      Busque el usuario por su documento de identidad
                      <v-icon small right> fas fa-user</v-icon>
                    </v-list-item-title>
                  </v-list-item>
                </template>

                <template v-slot:selection="{ attr, on, item, selected }">
                  <v-chip v-bind="attr" :input-value="selected" label small v-on="on">
                    <v-icon x-small left>
                      fas fa-user
                    </v-icon>
                    <span v-text="item.usu_usuario"></span>
                    <span class="ml-2">( {{ item.descripcion_perfil }} )</span>
                  </v-chip>
                </template>

                <template v-slot:item="{ item }">

                  <v-list-item-content>
                    <v-list-item-title> {{ item.usu_usuario }} </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-chip x-samll> {{ item.descripcion_perfil }} </v-chip>
                  </v-list-item-action>
                </template>



              </v-autocomplete>

            </v-col>


            <v-col cols="12">
              <v-text-field v-model="pUsuario.email" label="Correo electrónico" type="text" autocomplete="off" autofocus
                ref="email" :rules="validationRules.validateCorreo">
              </v-text-field>
            </v-col>

          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer />
          <ButtonComp @click="submitConfirm" :loading="loading" text-button="Enviar" color-button="primary"
            icon-but="fas fa-paper-plane" normal-button />
          <ButtonComp @click="closePassword" text-button="Cancelar" class-color="red" normal-button
            classButton="mx-2" />
        </template>
      </ComunDialogComp>
    </v-form>



    <!-- // Footer -->
    <!-- COMENTADO MIENTRAS SE DEFINE FUNCIONALIDAD -->
    <!-- <v-footer  absolute class="footer_style" >
            <v-col class="text-end" cols="12" ><a class="btn_style">LEGAL</a> -->
    <!-- {{ new Date().getFullYear() }} — <strong>Vuetify</strong> -->
    <!--   </v-col>
        </v-footer> -->
  </div>
</template>


<script>
import { mapActions, mapMutations } from "vuex";
import axios from "@/helpers/axios";
import ComunDialogComp from './ComponentsEst/ComunDialogComp.vue';
import ButtonComp from "./ComponentsEst/TableButtonComp.vue";
import { validationRules } from '../helpers/validatorHelpers';
export default {
  name: "login",
  components: {
    ComunDialogComp,
    ButtonComp
  },
  data() {

    return {
      isLoading: false,
      itemsUser: [],
      search: null,
      showDiv1: false,
      loading: false,
      showpass: false,
      dato: { usuario: "", password: "" },
      modal_password: false,
      usuarioDoc: "",

      pUsuario: {
        user: "",
        email: "",
      },
      tokentemp: null
    };
  },
 
  methods: {
    ...mapMutations({
      setEnviarMens: "mensajeSis/setEnviarMens"
    }),
    ...mapActions({
      verificarSession: "login/verificarSession"
    }),
    limpiarForm() {
      this.dato = { usuario: "", password: "" };
    },

    formKey(elem) {
      this.$refs[elem].focus();
    },

    async validarLogin() {

      try {
        let user = this.dato.usuario.trim();
        let pass = this.dato.password.trim();
        let params = { usuario: this.dato.usuario.trim(), password: this.dato.password.trim() };

        if (!user || !pass)
          return this.setEnviarMens({
            tipo: "W",
            mensaje: "Falta completar los campos.",
            tiempo: null,
          });

        const response = await axios.post("/sistema/main/validarLogin", params)

        if (response.data.messageT == "S") {
          this.verificarSession(response.data.payload);
        } else {
          this.setEnviarMens({ tipo: "W", mensaje: response.data.message, tiempo: null });
        }

      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Su usuario o contraseña es incorrecta.",
          tiempo: null,
        });
      }
    },

    // funciones de aperturas y cierres de modales para recuperar contraseña
    forgetPassword() {
      this.itemsUser = [];
      this.modal_password = true;
      this.borrarData();
    },

    closePassword() {
      this.modal_password = false;
    },

    borrarData() {
      this.pUsuario.user = "";
      this.pUsuario.email = "";
    },


    async submitConfirm() {
      try {
        this.loading = true;

        if (this.pUsuario.user.correo_persona === this.pUsuario.email) {
          let params = {
            idpersona: this.pUsuario.user.id,
            correo: this.pUsuario.email
          };
          let response = await axios.post(
            "/sistema/main/recoverPassword",
            params
          );

          if (JSON.stringify(response.data.mti) == JSON.stringify("S")) {
            this.closePassword();
            this.borrarData();
            this.setEnviarMens({
              tipo: "S",
              mensaje: response.data.message,
              tiempo: null,
            });
            this.pUsuario.user = "";
            this.pUsuario.email = "";
          } else {
            this.setEnviarMens({
              tipo: "W",
              mensaje: response.data.message,
              tiempo: null,
            });
          }

        } else {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "El correo electrónico no coincide con el usuario registrado",
            tiempo: null,
          });
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false;
        this.borrarData();
      }

    },
  },

  watch: {

    search(val) {
      // Items have already been loaded
      try {
        if (val.length <= 7) return; // No hagas la búsqueda si la longitud es menor o igual a 8
        this.isLoading = true;
        let params = {
          usuario: val, // Usar el valor de búsqueda actual
        };
        axios.post("/sistema/main/findusersRecovery", params)
          .then(response => {
            console.log(response.data, 'Esta es la respuesta del back');
            this.itemsUser = response.data[0];
          })
          .catch(error => {
            this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
          })
          .finally(() => {
            this.isLoading = false;
          });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        this.isLoading = false;
      }
    }
  },


  computed: {
    validationRules() {
      return validationRules;
    }

  }




};
</script>
<style>
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px rgb(8, 91, 167) inset;
  /* Cambia el color de fondo del cuadro */
  -webkit-text-fill-color: #fff;
  /*Cambia el color del texto */
}
</style>

<style scoped>
.conteprueba {
  background: #ffbc00;
  width: 30%;
  height: 400px;
  margin: auto;
}

.login {
  background: rgba(255, 255, 255, 0.2);
}

.btn_style {
  color: #fff !important;
  font-family: "avenir black";
  letter-spacing: 0.42px;
  font-size: 14px;
}

.v-btn {
  border-radius: 5px;
}

.btn_style:hover {
  font-family: "avenir black oblique";
  color: #ffbc00 !important;
}

.color_subtitle {
  color: #01579b;
  text-shadow: -1px -1px 1px #fff, 1px -1px 1px #fff, -1px 1px 1px #fff,
    1px 1px 1px #fff;
  font-family: "avenir black oblique";
  letter-spacing: 1.14px;
  font-size: 34px;
}

.a_style:hover {
  color: #ffbc00 !important;
  font-style: oblique;
  font-weight: bold;
}

.btn_block_style1 {
  font-family: "avenir black";
  letter-spacing: 0.42px;
  font-size: 14px;
}

.btn_block_style1:hover {
  font-family: "avenir black oblique";
  background-color: #ffbc00 !important;
}

.fade {
  animation: fadeIn 3s;
}

.fadeinverse {
  animation: fadeOut 2s;
}

@keyframes fadeOut {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
